import Comment from './Comment.vue';
export default (({
  Vue
}) => {
  Vue.component('Comment', Comment);
});